import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { PartnerGroup } from '../../../models/partner-group';
import { PartnerService } from '../../../services/partner.service';

@Component({
    selector: 'app-move-show-to-partner-group-modal',
    templateUrl: './move-show-to-partner-group-modal.component.html',
    styleUrls: ['./move-show-to-partner-group-modal.component.scss']
})
export class MoveShowToPartnerGroupModalComponent implements OnInit, OnDestroy {
    // a show row from get-partner-shows
    show: any;
    partnerGroups: PartnerGroup[] = [];
    selectedPartnerGroupId: number | null = null;
    saving = false;
    errorMessage = '';
    private _subscriptions: Subscription[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { show: any },
        private _dialogRef: MatDialogRef<MoveShowToPartnerGroupModalComponent>,
        private _partnerService: PartnerService
    ) {}

    ngOnInit() {
        this.show = this.data.show;
        this.selectedPartnerGroupId = this.show.partnerGroup_id;
        this._subscriptions.push(
            this._partnerService.getPartnerGroups().subscribe(groups => this.partnerGroups = groups)
        );
    }

    ngOnDestroy() {
        this._subscriptions.forEach(s => s.unsubscribe());
        this._subscriptions = [];
    }

    get currentPartnerGroupName() {
        const group = this.partnerGroups.find(g => g.id === this.show.partnerGroup_id);
        return group ? group.name : '';
    }

    // nothing to move until a different group is picked
    get canSubmit() {
        return !this.saving && this.selectedPartnerGroupId !== null && this.selectedPartnerGroupId !== this.show.partnerGroup_id;
    }

    trackById(_: number, item: { id: number }) {
        return item.id;
    }

    submit() {
        if (!this.canSubmit) {
            return;
        }
        this.saving = true;
        this.errorMessage = '';
        this._subscriptions.push(
            this._partnerService.updateProShowPartnerGroup(this.show.id, this.selectedPartnerGroupId).subscribe(
                updatedShow => this._dialogRef.close(updatedShow),
                () => {
                    this.saving = false;
                    this.errorMessage = 'The show could not be moved. Try again.';
                }
            )
        );
    }

    cancel() {
        this._dialogRef.close();
    }
}
